import { render, staticRenderFns } from "./workReports.vue?vue&type=template&id=235e1f7e&scoped=true"
import script from "./workReports.vue?vue&type=script&lang=js"
export * from "./workReports.vue?vue&type=script&lang=js"
import style0 from "./workReports.vue?vue&type=style&index=0&id=235e1f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235e1f7e",
  null
  
)

export default component.exports